import { Users, Mail, Building } from 'lucide-react';
import { Badge } from '../ui/badge';

export default function CustomersTab({ detailedUsers }) {
  const roleColors = {
    customer: 'bg-stone-100 text-stone-700',
    admin: 'bg-blue-100 text-blue-700',
    master_admin: 'bg-gradient-to-r from-yellow-500 to-orange-500 text-white'
  };

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <h1 className="text-2xl font-bold text-stone-900">Gestión de Clientes</h1>
        <div className="text-sm text-stone-500">
          {detailedUsers.length} usuarios registrados
        </div>
      </div>

      <div className="bg-white rounded-2xl border border-stone-200 overflow-hidden">
        <div className="overflow-x-auto">
          <table className="w-full">
            <thead className="bg-stone-50 border-b border-stone-200">
              <tr>
                <th className="px-4 py-3 text-left text-sm font-semibold text-stone-600">Usuario</th>
                <th className="px-4 py-3 text-left text-sm font-semibold text-stone-600">Empresa</th>
                <th className="px-4 py-3 text-left text-sm font-semibold text-stone-600">Rol</th>
                <th className="px-4 py-3 text-left text-sm font-semibold text-stone-600">Pedidos</th>
                <th className="px-4 py-3 text-left text-sm font-semibold text-stone-600">Total Gastado</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-stone-100">
              {detailedUsers.map(user => (
                <tr key={user.user_id} className="hover:bg-stone-50">
                  <td className="px-4 py-3">
                    <div className="flex items-center gap-3">
                      {user.picture ? (
                        <img src={user.picture} alt="" className="w-10 h-10 rounded-full object-cover" />
                      ) : (
                        <div className="w-10 h-10 bg-emerald-100 rounded-full flex items-center justify-center">
                          <Users className="w-5 h-5 text-emerald-700" />
                        </div>
                      )}
                      <div>
                        <p className="font-medium text-stone-900">{user.name}</p>
                        <p className="text-sm text-stone-500 flex items-center gap-1">
                          <Mail className="w-3 h-3" />
                          {user.email}
                        </p>
                      </div>
                    </div>
                  </td>
                  <td className="px-4 py-3">
                    {user.company ? (
                      <div className="flex items-center gap-1">
                        <Building className="w-4 h-4 text-stone-400" />
                        <span className="text-sm text-stone-700">{user.company}</span>
                      </div>
                    ) : (
                      <span className="text-sm text-stone-400">-</span>
                    )}
                  </td>
                  <td className="px-4 py-3">
                    <Badge className={roleColors[user.role] || roleColors.customer}>
                      {user.role === 'master_admin' ? 'Master Admin' : 
                       user.role === 'admin' ? 'Admin' : 'Cliente'}
                    </Badge>
                  </td>
                  <td className="px-4 py-3 text-sm text-stone-700">
                    {user.order_count || 0}
                  </td>
                  <td className="px-4 py-3 font-semibold text-emerald-700">
                    ${user.total_spent?.toLocaleString() || 0}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        {detailedUsers.length === 0 && (
          <div className="text-center py-12 text-stone-500">
            No hay usuarios registrados
          </div>
        )}
      </div>
    </div>
  );
}
